import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'semantic-ui-react';

// Toggle to track whether or not a specific graph is visible in the reports tab.
// There is a toggle per graph e.g one for the trend graph on for the individual rate of change graph per eval plan

export function EvaluationReportInclusionToggle({
  evaluation,
  isDisabled,
  chartMode,
  putEvaluationReportInclusion,
}) {
  const { t } = useTranslation();

  const [trendIncluded, setTrendIncluded] = useState(
    () => evaluation?.trendInReport !== false
  );
  const [individualIncluded, setIndividualIncluded] = useState(
    () => evaluation?.individualInReport !== false
  );

  const isIndividual = chartMode === 'individual';
  const active = isIndividual ? individualIncluded : trendIncluded;

  const onChange = (status) => {
    if (isIndividual) setIndividualIncluded(status);
    else setTrendIncluded(status);
    putEvaluationReportInclusion(
      evaluation.projectId,
      evaluation.id,
      isIndividual ? 'individual' : 'trend',
      status
    );
  };

  return (
    <div className="outcome-summary-intercept-flex-item">
      <div className="checkbox-container-include-in-report">
        <div className="include-in-report-label">
          {t('report.include_graph_in_report')}
        </div>
        <div className="button-include">
          <Button.Group
            className="btn-include-in-report"
            onClick={() => !isDisabled && onChange(!active)}
          >
            <Button active={active} disabled={isDisabled}>
              {t('actions.yes')}
            </Button>
            <Button active={!active} disabled={isDisabled}>
              {t('actions.no')}
            </Button>
          </Button.Group>
        </div>
      </div>
    </div>
  );
}
